import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";

function About() {
  const { t, i18n, iUrl, parse } = useGlobal();
  return (
    <section className="about-section lg:py-16 bg-bg-alt-100">
      <div className="about-section__container">
        {/* Section Title */}

        <div className="about-section__content-wrapper flex flex-col lg:grid lg:grid-cols-2 lg:max-w-content lg:mx-auto lg:px-8 lg:gap-12 lg:items-start">
          {/* Left - Creator Photo */}
          <div className="about-section__image-wrapper w-full">
            <img
              src={`${iUrl}${t("sections_data.7.section_cover")}?format=webp`}
              alt="Ceramic artist portrait"
              className="about-section__image w-full aspect-[2/3] object-cover  shadow-lg"
            />
          </div>

          {/* Right - Text Content */}
          <div className="about-section__content space-y-6 py-16 lg:py-0 px-8 lg:px-0">
            <h3 className="font-medium about-section__title font-header text-4xl lg:text-5xl text-secondary-700 mb-12">
              {t("sections_data.7.section_heading")}
            </h3>
            <div className="workwithme-section__paragraph font-body text-lg text-dark-700 leading-relaxed [&_p]:mb-12 [&_ul]:list-disc">
              {parse(t("sections_data.7.section_body"))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
